/**
 * Sparkle Cursor Effect
 * Creates a small cluster of sparkles that follow the mouse around
 */

(function() {
  // Sparkle SVG template
  const sparkleSVG = `
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.8,32.2l-10.3-3.8a1.5,1.5,0,0,1,0-2.8l10.3-3.8l3.8-10.3a1.5,1.5,0,0,1,2.8,0l3.8,10.3l10.3,3.8a1.5,1.5,0,0,1,0,2.8l-10.3,3.8l-3.8,10.3a1.5,1.5,0,0,1-2.8,0Z" fill="currentColor"/>
    </svg>
  `;

  // Colors from Ruinette palette
  const sparkleColors = [
    '#c9d762', // peridot
    '#f8afbe', // rose quartz
    '#2b4a8d', // sapphire
    '#F6D2D9', // pink opal
  ];

  // Sparkle sizes (more variability)
  const sparkleSizes = [10, 14, 20, 28, 36];

  // Cluster configuration
  const clusterSize = 8; // Number of sparkles in the cluster (more for tail)
  const sparkles = [];
  let mouseX = 0;
  let mouseY = 0;
  let isActive = false;
  let isMobile = false;
  let tapFadeTimeout = null;

  // Create sparkle elements
  function createSparkleElement(index) {
    const sparkle = document.createElement('div');
    sparkle.className = 'cursor-sparkle';
    sparkle.innerHTML = sparkleSVG;

    // Front sparkles are bigger, tail sparkles get smaller
    const sizeIndex = index < 4 ? index % sparkleSizes.length : Math.max(0, sparkleSizes.length - 1 - (index - 4));
    const size = sparkleSizes[sizeIndex];
    const color = sparkleColors[index % sparkleColors.length];

    sparkle.style.cssText = `
      position: fixed;
      pointer-events: none;
      z-index: 9998;
      width: ${size}px;
      height: ${size}px;
      color: ${color};
      opacity: 0;
      transform: scale(0);
      transition: opacity 0.3s ease, transform 0.3s ease;
      filter: drop-shadow(0 0 2px ${color});
    `;

    document.body.appendChild(sparkle);

    return {
      element: sparkle,
      x: 0,
      y: 0,
      targetX: 0,
      targetY: 0,
      offsetX: (Math.random() - 0.5) * 60,
      offsetY: (Math.random() - 0.5) * 60,
      delay: index * 0.08, // Stagger the following
      size: size,
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 2,
      twinklePhase: Math.random() * Math.PI * 2,
      twinkleSpeed: 2 + Math.random() * 2
    };
  }

  // Initialize sparkles
  function init() {
    // Detect mobile/touch device
    isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    for (let i = 0; i < clusterSize; i++) {
      sparkles.push(createSparkleElement(i));
    }

    if (isMobile) {
      // Mobile: show sparkles on tap, fade after delay
      document.addEventListener('touchstart', (e) => {
        if (e.touches.length > 0) {
          mouseX = e.touches[0].clientX;
          mouseY = e.touches[0].clientY;

          // Immediately position sparkles at tap location
          sparkles.forEach((sparkle) => {
            sparkle.x = mouseX + sparkle.offsetX;
            sparkle.y = mouseY + sparkle.offsetY;
            sparkle.targetX = sparkle.x;
            sparkle.targetY = sparkle.y;
          });

          // Show sparkles
          isActive = true;
          showSparkles();

          // Clear any existing fade timeout
          if (tapFadeTimeout) {
            clearTimeout(tapFadeTimeout);
          }

          // Fade out after 800ms
          tapFadeTimeout = setTimeout(() => {
            isActive = false;
            hideSparkles();
          }, 800);
        }
      }, { passive: true });
    } else {
      // Desktop: follow mouse continuously
      document.addEventListener('mousemove', (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;

        if (!isActive) {
          isActive = true;
          showSparkles();
        }
      });

      // Hide sparkles when mouse leaves window
      document.addEventListener('mouseleave', () => {
        isActive = false;
        hideSparkles();
      });
    }

    // Start animation loop
    animate();
  }

  function showSparkles() {
    sparkles.forEach((sparkle, i) => {
      setTimeout(() => {
        sparkle.element.style.opacity = '0.8';
        sparkle.element.style.transform = 'scale(1)';
      }, i * 50);
    });
  }

  function hideSparkles() {
    sparkles.forEach((sparkle, i) => {
      setTimeout(() => {
        sparkle.element.style.opacity = '0';
        sparkle.element.style.transform = 'scale(0)';
      }, i * 30);
    });
  }

  function animate() {
    const time = Date.now() * 0.001;

    sparkles.forEach((sparkle, i) => {
      // Calculate target position with offset
      sparkle.targetX = mouseX + sparkle.offsetX;
      sparkle.targetY = mouseY + sparkle.offsetY;

      // Smooth follow with easing (slower for sparkles further back to create tail)
      const ease = 0.18 - (i * 0.018);
      sparkle.x += (sparkle.targetX - sparkle.x) * ease;
      sparkle.y += (sparkle.targetY - sparkle.y) * ease;

      // Update rotation
      sparkle.rotation += sparkle.rotationSpeed;

      // Twinkle effect
      const twinkle = 0.6 + Math.sin(time * sparkle.twinkleSpeed + sparkle.twinklePhase) * 0.4;

      // Apply position and effects
      if (isActive) {
        sparkle.element.style.left = `${sparkle.x - sparkle.size / 2}px`;
        sparkle.element.style.top = `${sparkle.y - sparkle.size / 2}px`;
        sparkle.element.style.transform = `scale(${twinkle}) rotate(${sparkle.rotation}deg)`;
        sparkle.element.style.opacity = twinkle * 0.8;
      }
    });

    requestAnimationFrame(animate);
  }

  // Add CSS
  const style = document.createElement('style');
  style.textContent = `
    .cursor-sparkle svg {
      width: 100%;
      height: 100%;
    }
    .cursor-sparkle {
      will-change: transform, opacity, left, top;
    }
  `;
  document.head.appendChild(style);

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
